import { render, staticRenderFns } from "./DashboardProducer.vue?vue&type=template&id=7a6436cd&"
import script from "./DashboardProducer.vue?vue&type=script&lang=js&"
export * from "./DashboardProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports